import React from 'react';
import { NavLink } from 'react-router-dom';
import { authHeader, subDomain } from './Common';
import { GetAccessModulesByRoleId } from "../services/AccessModulesServices";
class NavBar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            UserDetails: authHeader(),
            SubDomain: subDomain(),
            userAccessModules: []
        };
    }
    componentDidMount() {
        if (this.state.UserDetails != null) {
            let RoleIds = this.state.UserDetails.UserRoleIds;
            if (RoleIds != null) {
                this._GetAccessModulesByRoleId(RoleIds);
            }
        }

    }
    htmlDecode(input) {
        var e = document.createElement('span');
        e.innerHTML = input;
        return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
    }

    _GetAccessModulesByRoleId = (RoleId) => {
        GetAccessModulesByRoleId(RoleId).then(res => {
            let response = res;
            if (response.message !== Error) {
                if (response.status === true) {
                    this.setState({ userAccessModules: response.data });
                }
            }
        });
    }
    render() {
        let url = this.state.SubDomain.SubDomain === 'Xgen' ? "" : "/" + this.state.SubDomain.SubDomain;
        const { userAccessModules } = this.state;
        return (
            <>
                <nav id="sidebar" className="align-items-start align-content-start sidebar navbar sidebar active">
                    <NavLink to="#" className={`sidebar-brand px-4 py-3 w-100 text-center `}>
                        {/*<img src={logoUrl} alt="Company Logo" className={url === 'Xgen' ? 'logo' : 'logo-100p'} />*/}
                        <img src={this.state.SubDomain !== null ? this.state.SubDomain.LogoPath : "assets/Content/images/xgen-logo.png"} alt="Company Logo" />
                    </NavLink>
                    <ul className="list-unstyled w-100">
                        <li className="sidebar-header pt-4 ps-3 pe-2 pb-1">
                            <strong className="text-black">Pages</strong>
                        </li>
                        {(userAccessModules !== null && userAccessModules.length !== 0) &&
                            userAccessModules.map((route, index) => (
                                route.is_Navbar === true &&
                                <li className="sidebar-item" key={index}>
                                    <NavLink exact activeClassName="ActiveSidebar" to={url + "" + route.moduleURL} className="sidebar-link d-block p-3 ps-4 text-decoration-none">
                                        <span dangerouslySetInnerHTML={{ __html: this.htmlDecode(route.navBarIcon) }}></span>
                                        <span className="align-middle">{route.displayName}</span>
                                    </NavLink>
                                </li>
                            ))
                        }
                    </ul>
                </nav>
            </>
        );
    }
}

export { NavBar };